// src/components/DateSelector.tsx
import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box, Typography } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';

type Props = {
  selectedDate: Dayjs | null;
  onChange: (newDate: Dayjs | null) => void;
  workDays: number[]; // e.g. [1, 2, 3, 4, 5] for Mon–Fri
  availableDates?: string[]; // Array of date strings in YYYY-MM-DD format
};

export default function DateSelector({ selectedDate, onChange, workDays, availableDates }: Props) {
  const isDisabled = (date: Dayjs) => {
    // If availableDates is provided, use it exclusively (it already accounts for work days)
    if (availableDates !== undefined) {
      const dateString = date.format('YYYY-MM-DD');
      return !availableDates.includes(dateString);
    }
    
    // Fallback: just check if it's a work day
    return !workDays.includes(date.day());
  };

  return (
    <Box sx={{ mt: 4 }}>
      <DatePicker
        label="Select Date"
        value={selectedDate}
        onChange={onChange}
        disablePast
        shouldDisableDate={isDisabled}
        slotProps={{
          textField: { fullWidth: true },
        }}
      />
    </Box>
  );
}
